import React, { useEffect } from 'react';
import CentralIaSidebar from 'components/organisms/central_ia_sidebar';
import CentralIaChatArea from 'components/atoms/central_ia_chat_area';
import AmbassadorFeedbackBar from 'components/molecules/ambassador_feedback_bar';
import { AMBASSADOR_FEEDBACK_BAR_HEIGHT } from 'components/molecules/ambassador_feedback_bar/styles';
import { useAmbassadorTesting } from 'hooks/useAmbassadorTesting';
import createTrack from 'services/actions/tracker_actions';
import { CENTRAL_IA_AMBASSADOR_SLUG } from 'services/ambassador_tools';
import { Container } from './styles';

const CentralIA: React.FC = () => {
  const ambassadorTesting = useAmbassadorTesting(CENTRAL_IA_AMBASSADOR_SLUG);

  useEffect(() => {
    document.title = 'Central IA - ConLicitação';
    createTrack('Central IA - Acessou a página');
  }, []);

  return (
    <>
      <Container $bottomOffset={ambassadorTesting ? AMBASSADOR_FEEDBACK_BAR_HEIGHT : 0}>
        <CentralIaSidebar />
        <CentralIaChatArea />
      </Container>
      {ambassadorTesting && <AmbassadorFeedbackBar toolSlug={CENTRAL_IA_AMBASSADOR_SLUG} />}
    </>
  );
};

export default CentralIA;
